<template>
  <div id="pop-alert" :class="{'popAlert': true, 'show': show}">
    <div v-if="isSimpleMessage" class="c-history-detail mb-8" @click.prevent="$router.push(linkTo)">
      <div class="c-history-detail__content">
        <div class="c-history-detail__content--time mb-8">
          {{date}} <span>{{time}}</span>
        </div>
        <div class="c-history-detail__content--title mb-8">
          <div class="title">{{title}}</div>
        </div>
        <div class="c-history-detail__receipt">
          {{message}}
        </div>
      </div>
      <div class="c-history-detail__icon" v-if="linkTo">
        <router-link :to="linkTo">
          <img src="/assets/images/icon/icon-arrow-right-white.svg" alt="" />
        </router-link>
      </div>
    </div>
    <div v-else class="c-history-detail mb-8" @click.prevent="$router.push(linkTo)">
      <div class="c-history-detail__content">
        <div class="c-history-detail__content--time mb-8">
          {{date}} <span>{{time}}</span>
        </div>
        <div class="c-history-detail__content--title mb-8" v-if="provider">
          <div class="icon">
            <img :src="getImgSrc(provider && provider.image && provider.image[0])" alt="" />
          </div>
          <div class="title">{{provider.shopName}}</div>
        </div>
        <div class="c-history-detail__receipt">
          {{message}}
        </div>
      </div>
      <div class="c-history-detail__icon" v-if="linkTo">
        <router-link :to="linkTo">
          <img src="/assets/images/icon/icon-arrow-right-white.svg" alt="" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import dayjs from "dayjs";
import { eventBus } from "../common/common";
import { IMG_HOST } from "../config/const";
import store from "../store";

export default Vue.extend({
  name: 'PopAlert',
  components: {
  },
  store,
 created() {
    var _this = this;
    eventBus.$on('orderUpdated', function(orderData, status, changedAt) {
      console.log('orderUpdated');
      console.log(orderData);
      const orderId = orderData.id;
      let changedAtData = changedAt;
      if (!changedAt) {
        changedAtData = Date.now();
      }
      switch (status){
        case "PREPARING":
          if (orderData.handlingFormat == '5') {
            _this.message = "ご予約が確定しました。";
          } else {
            _this.message = "ご注文を確認いたしました。商品の準備を始めます。";
          }
          break;
        case "PREPARED":
          if (orderData.handlingFormat == '1' || orderData.handlingFormat == '2') {
            _this.message = "ご注文商品の準備ができました";
          } else if (orderData.handlingFormat == '3' || orderData.handlingFormat == '4') {
            _this.message = "ご注文商品のお届けの準備をしています";
          } else if (orderData.handlingFormat == '5') {
            _this.message = "ご案内の準備ができましたので、ご来店ください";
          }
          break;
        case "DELIVERING":
          _this.message = "ご注文商品をお届け中です";
          break;
        case "CANCEL_SUCCEED":
          if (orderData.handlingFormat == '5') {
            _this.message = "ご予約がキャンセルされました";
          } else {
            _this.message = "ご注文がキャンセルされました";
          }
          break;
        case "CANCEL_REQUESTED":
          if (orderData.handlingFormat == '5') {
            _this.message = "ご予約がキャンセルされました";
          } else {
            _this.message = "ご注文がキャンセルされました";
          }
          break;
        case "POSTPONED":
          if (orderData.handlingFormat == '5') {
            _this.message = "ご案内に時間がかかっています";
          } else {
            _this.message = "ご注文のご用意に時間がかかっています";
          }
          break;
        case "COMPLETED":
          if (orderData.handlingFormat == '5') {
            _this.message = "ご来店いただきありがとうございました";
          } else {
            _this.message = "ご注文商品のお渡しが完了しました";
          }
          break;
        case "REQUESTCONTACT":
          if (orderData.handlingFormat == '5') {
            _this.message = "ご来店予約内容についてお伝えしたいことがあります。店舗までご連絡ください。";
          } else {
            _this.message = "ご注文商品についてお伝えしたいことがあります。店舗までご連絡ください。";
          }
          break;
      }
      _this.date = dayjs(changedAt).format('YYYY/M/D');
      _this.time = dayjs(changedAt).format('HH:mm');
      _this.provider = orderData.provider;
      _this.linkTo = '/mobileorder/history/item/'+orderId;
      _this.show = true;
      setTimeout(() => {
        _this.show = false;
      }, 10000);
    })
    eventBus.$on('messageReceived', function(data) {
      console.log('messageReceived');
      console.log('data', data);
      _this.date = dayjs().format('YYYY/M/D');
      _this.time = dayjs().format('HH:mm');
      _this.title = data.title;
      _this.message = data.body;
      _this.linkTo = data.link;
      _this.isSimpleMessage = true;
      _this.show = true;
      setTimeout(() => {
        _this.show = false;
        _this.isSimpleMessage = false;
      }, 10000);
    })
  },
  data() {
    return {
      title: "",
      message: "",
      show: false,
      isSimpleMessage: false,
      provider: undefined,
      orderId: undefined,
      linkTo: undefined,
      date: undefined,
      time: undefined
    }
  },
  methods: {
    getImgSrc (src) {
      if (!src) { return '' }
      if (src.indexOf('http') != -1) {
        return src;
      }
      return IMG_HOST + src;
    },
  }
})
</script>

